import { combineReducers } from 'redux';

import stack from './stack';

/**
 * @typedef {{
 *  stack: import('./stack').State
 * }} SelectState
 */

export default combineReducers({
  stack,
});
